import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ScaleYourAgencyWithoutRisk from "./sections/ScaleYourAgencyWithoutRisk";
import Benefits from "./sections/Benefits";
import Agentbenefits from "./sections/Agentbenefits";
import TheRmaAdvantage from "./sections/TheRmaAdvantage";
import ThePerformanceModel from "./sections/ThePerformanceModel";
import OurGrowthEngine from "./sections/OurGrowthEngine";
import AgentSuccessStories from "./sections/AgentSuccessStories";
import ReadyToSubmitCustomers from "./sections/ReadyToSubmitCustomers";
import FooterInformation from "@/reusable_sections/Footer";
import AboutUs from "./sections/AboutUs";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ScaleYourAgencyWithoutRisk />
      <AboutUs />
      <Benefits />
      <Agentbenefits />
      <TheRmaAdvantage />
      <ThePerformanceModel />
      <OurGrowthEngine />
      <AgentSuccessStories />
      <ReadyToSubmitCustomers />
      <FooterInformation />
    </div>;
}